import { render, staticRenderFns } from "./AreaNegociacao.vue?vue&type=template&id=5e901aec"
import script from "./AreaNegociacao.vue?vue&type=script&lang=js"
export * from "./AreaNegociacao.vue?vue&type=script&lang=js"
import style0 from "./AreaNegociacao.vue?vue&type=style&index=0&id=5e901aec&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports